import setAuth from "./setAuth"
import mtd from "./method"
import _debounce from "lodash/debounce"
import uuidv4 from "uuid/v4"
import Swiper from "swiper"
import "swiper/dist/css/swiper.min.css"

let params = {
    setAuth,
    mtd,
    _debounce,
    uuidv4,
    Swiper
}

function setGlobal(params) {
    let keys = Object.keys(params)
    keys.forEach(el => {
        if (el in window === false) {
            window[el] = params[el]
        }
    })
}

setGlobal(params)
